<h1 mat-dialog-title>{{ "instructionTitle" | translate }}</h1>
<div mat-dialog-content>
  <embed [src]="pdfUrl | safe" style="width: 100%;height: 500px" type="application/pdf">
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true">{{ "close" | translate }}</button>
</div>
